"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Geometry = _interopRequireDefault(require("../../geom/Geometry"));

var _PointGeometryUnion = _interopRequireDefault(require("./PointGeometryUnion"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _Collection = _interopRequireDefault(require("../../../../../java/util/Collection"));

var _SnapIfNeededOverlayOp = _interopRequireDefault(require("../overlay/snap/SnapIfNeededOverlayOp"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _GeometryExtracter = _interopRequireDefault(require("../../geom/util/GeometryExtracter"));

var _OverlayOp = _interopRequireDefault(require("../overlay/OverlayOp"));

var _CascadedPolygonUnion = _interopRequireDefault(require("./CascadedPolygonUnion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UnaryUnionOp =
/*#__PURE__*/
function () {
  function UnaryUnionOp() {
    _classCallCheck(this, UnaryUnionOp);

    UnaryUnionOp.constructor_.apply(this, arguments);
  }

  _createClass(UnaryUnionOp, [{
    key: "unionNoOpt",
    value: function unionNoOpt(g0) {
      var empty = this._geomFact.createPoint();

      return _SnapIfNeededOverlayOp.default.overlayOp(g0, empty, _OverlayOp.default.UNION);
    }
  }, {
    key: "unionWithNull",
    value: function unionWithNull(g0, g1) {
      if (g0 === null && g1 === null) return null;
      if (g1 === null) return g0;
      if (g0 === null) return g1;
      return g0.union(g1);
    }
  }, {
    key: "extract",
    value: function extract() {
      if ((0, _hasInterface.default)(arguments[0], _Collection.default)) {
        var geoms = arguments[0];

        for (var i = geoms.iterator(); i.hasNext();) {
          var geom = i.next();
          this.extract(geom);
        }
      } else if (arguments[0] instanceof _Geometry.default) {
        var _geom = arguments[0];
        if (this._geomFact === null) this._geomFact = _geom.getFactory();

        _GeometryExtracter.default.extract(_geom, _Geometry.default.TYPENAME_POLYGON, this._polygons);

        _GeometryExtracter.default.extract(_geom, _Geometry.default.TYPENAME_LINESTRING, this._lines);

        _GeometryExtracter.default.extract(_geom, _Geometry.default.TYPENAME_POINT, this._points);
      }
    }
  }, {
    key: "union",
    value: function union() {
      if (this._geomFact === null) {
        return null;
      }

      var unionPoints = null;

      if (this._points.size() > 0) {
        var ptGeom = this._geomFact.buildGeometry(this._points);

        unionPoints = this.unionNoOpt(ptGeom);
      }

      var unionLines = null;

      if (this._lines.size() > 0) {
        var lineGeom = this._geomFact.buildGeometry(this._lines);

        unionLines = this.unionNoOpt(lineGeom);
      }

      var unionPolygons = null;

      if (this._polygons.size() > 0) {
        unionPolygons = _CascadedPolygonUnion.default.union(this._polygons);
      }

      var unionLA = this.unionWithNull(unionLines, unionPolygons);
      var union = null;
      if (unionPoints === null) union = unionLA;else if (unionLA === null) union = unionPoints;else union = _PointGeometryUnion.default.union(unionPoints, unionLA);
      if (union === null) return this._geomFact.createGeometryCollection();
      return union;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return UnaryUnionOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "union",
    value: function union() {
      if (arguments.length === 1) {
        if ((0, _hasInterface.default)(arguments[0], _Collection.default)) {
          var geoms = arguments[0];
          var op = new UnaryUnionOp(geoms);
          return op.union();
        } else if (arguments[0] instanceof _Geometry.default) {
          var geom = arguments[0];
          var op = new UnaryUnionOp(geom);
          return op.union();
        }
      } else if (arguments.length === 2) {
        var _geoms = arguments[0],
            geomFact = arguments[1];
        var op = new UnaryUnionOp(_geoms, geomFact);
        return op.union();
      }
    }
  }]);

  return UnaryUnionOp;
}();

exports.default = UnaryUnionOp;

UnaryUnionOp.constructor_ = function () {
  this._polygons = new _ArrayList.default();
  this._lines = new _ArrayList.default();
  this._points = new _ArrayList.default();
  this._geomFact = null;

  if (arguments.length === 1) {
    if ((0, _hasInterface.default)(arguments[0], _Collection.default)) {
      var geoms = arguments[0];
      this.extract(geoms);
    } else if (arguments[0] instanceof _Geometry.default) {
      var geom = arguments[0];
      this.extract(geom);
    }
  } else if (arguments.length === 2) {
    var _geoms2 = arguments[0],
        geomFact = arguments[1];
    this._geomFact = geomFact;
    this.extract(_geoms2);
  }
};